// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.panoramax-body {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
}

div.panoramax-body .pnx-psv-tour-arrows {
    all: unset;
}

div.panoramax-body .gvs-btn:focus {
    outline: none;
}

.panoramax-widget {
    background-color: rgba(255, 255, 255, 0.7);
    color: #333;
    font-weight: bolder;
    padding: 10px;
    border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/Panoramax.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB","sourcesContent":["div.panoramax-body {\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\ndiv.panoramax-body .pnx-psv-tour-arrows {\n    all: unset;\n}\n\ndiv.panoramax-body .gvs-btn:focus {\n    outline: none;\n}\n\n.panoramax-widget {\n    background-color: rgba(255, 255, 255, 0.7);\n    color: #333;\n    font-weight: bolder;\n    padding: 10px;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
